var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, toJS, makeObservable } from 'mobx';
import { runtime } from '../../../classes/runtime/Runtime';
export class MobxLocalStorage {
    storage = observable.map();
    nativeStorage;
    constructor(type) {
        makeObservable(this);
        if (runtime.isServerRuntime)
            return;
        if (type === 'session') {
            this.nativeStorage = sessionStorage;
        }
        else {
            this.nativeStorage = localStorage;
        }
        this.readFromNative();
    }
    get length() {
        return this.storage.size;
    }
    getItem(key) {
        return this.storage.has(key) ? this.storage.get(key) : null;
    }
    setItem(key, value, options = {}) {
        this.storage.set(key, value);
        this.nativeStorage.setItem(key, value);
        if (options.expire) {
            const expireValue = (new Date().getTime() + options.expire * 1000).toString();
            this.storage.set(`expire_${key}`, expireValue);
            this.nativeStorage.setItem(`expire_${key}`, expireValue);
        }
    }
    clear() {
        this.storage.clear();
    }
    getObject(key) {
        const item = this.getItem(key);
        if (!item)
            return undefined;
        return JSON.parse(item);
    }
    setObject(key, value) {
        this.setItem(key, JSON.stringify(toJS(value)));
        return this;
    }
    removeItem(key) {
        const has = this.storage.has(key);
        this.storage.delete(key);
        this.nativeStorage.removeItem(key);
        return has;
    }
    readFromNative() {
        if (runtime.isServerRuntime)
            return;
        if (!this.nativeStorage)
            return;
        const nativeKeys = Object.keys(this.nativeStorage);
        for (const key of nativeKeys) {
            this.storage.set(key, this.nativeStorage.getItem(key));
        }
        for (const key of nativeKeys) {
            if (key.startsWith('expire_')) {
                const expireTime = parseInt(key.split('expire_')[1]);
                if (expireTime < new Date().getTime()) {
                    const expiredKey = this.nativeStorage.getItem(key);
                    this.storage.delete(key);
                    this.storage.delete(expiredKey);
                    this.nativeStorage.removeItem(key);
                    this.nativeStorage.removeItem(expiredKey);
                }
            }
        }
    }
}
__decorate([
    observable.shallow
], MobxLocalStorage.prototype, "storage", void 0);
__decorate([
    action
], MobxLocalStorage.prototype, "clear", null);
__decorate([
    action
], MobxLocalStorage.prototype, "getObject", null);
__decorate([
    action
], MobxLocalStorage.prototype, "setObject", null);
__decorate([
    action
], MobxLocalStorage.prototype, "removeItem", null);
__decorate([
    action.bound
], MobxLocalStorage.prototype, "readFromNative", null);
export const localStore = new MobxLocalStorage('local');
export const sessionStore = new MobxLocalStorage('session');
